exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.divideContaner[data-v-6480b99c] {\n  height: 100%;\n  width: 100%;\n  background: #D9D9D9;\n}\n.divideContaner .divideImage[data-v-6480b99c] {\n  height: 100%;\n  width: 60px;\n  margin: 0 auto;\n}\n", "", {"version":3,"sources":["D:/bojun/burgeon-UI/src/components/split-panel/divide-vertical.vue"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,YAAY;EACZ,oBAAoB;CACrB;AACD;EACE,aAAa;EACb,YAAY;EACZ,eAAe;CAChB","file":"divide-vertical.vue","sourcesContent":["\n.divideContaner[data-v-6480b99c] {\n  height: 100%;\n  width: 100%;\n  background: #D9D9D9;\n}\n.divideContaner .divideImage[data-v-6480b99c] {\n  height: 100%;\n  width: 60px;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-6480b99c","scoped":true,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/split-panel/divide-vertical.vue
// module id = 677
// module chunks = 0